import { registerBlockType } from "@wordpress/blocks";
import metadata from "./block.json";
import Save from "./save";
import Edit from "./Edit";

registerBlockType(metadata.name, {
  edit: Edit,
  save: Save,
  icon: {
    foreground: "#0061FE",
    src: (
      <svg
        id="a"
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
      >
        <path
          d="m18,2.2H6c-2.1,0-3.8,1.7-3.8,3.8v12c0,2.1,1.7,3.8,3.8,3.8h12c2.1,0,3.8-1.7,3.8-3.8V6c0-2.1-1.7-3.8-3.8-3.8Zm2.2,15.8c0,1.2-1,2.2-2.2,2.2H6c-1.2,0-2.2-1-2.2-2.2V6c0-1.2,1-2.2,2.2-2.2h12c1.2,0,2.2,1,2.2,2.2v12Z"
          stroke-width="0"
        />
        <path
          d="m14.8,13.1c-.3-.2-.5-.3-.8-.4-.2-.1-.4,0-.6.1l-.4.4q-.1.1-.2,0c-1-.4-1.7-1.1-2.1-2q-.1-.2.1-.4c.1-.1.3-.2.4-.4.1-.1.1-.3.1-.4s-.1-.2-.1-.2c-.3-.6-.6-1.1-1-1.6l-.1-.1c-.2-.1-.4-.2-.6,0,0,0-.1,0-.1.1-.5.4-1,1-1.3,1.6-.1.1-.1.3-.1.4.1.6.3,1.1.6,1.7.6,1,1.3,1.9,2.2,2.6.6.5,1.3,1,2.1,1.2.3.1.7.2,1,.2h0s.1,0,.2-.1c.6-.3,1.1-.8,1.6-1.3.1-.1.1-.2.2-.3v-.2c0-.2-.1-.3-.2-.4-.3-.1-.6-.3-.9-.5Z"
          stroke-width="0"
        />
      </svg>
    ),
  },
});
